var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBandcampLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7 .969A6.78 6.78 0 0 0 .219 7.75 6.78 6.78 0 0 0 7 14.531a6.78 6.78 0 0 0 6.781-6.781A6.78 6.78 0 0 0 7 .969M8.313 9.91h-4.95L5.66 5.617h4.95z"
})));
export default SvgBandcampLogo;